module.exports = __webpack_public_path__ + "static/media/37_tn.f3ef9844.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/37_tn.jpg
// module id = 250
// module chunks = 0